import CustomForm from "../CustomForm";

export default abstract class Tree extends CustomForm {

}